import { Box, ChakraProvider } from "@chakra-ui/react";

import "./App.css";

import { Toaster } from "react-hot-toast";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import ErrorBoundary from "./components/errorBoundary";
import chakraTheme from "./lib/chakra/theme";
import AppRouter from "./routes/appRouter";

function App() {
  const queryClient = new QueryClient();

  return (
    <ErrorBoundary>
      <RecoilRoot>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <ChakraProvider theme={chakraTheme}>
              <Box
                w={"100vw"}
                overflowX={"hidden"}
                minH={"100vh"}
                bg={"background"}
              >
                <AppRouter />
                <Toaster
                  position="top-center"
                  containerStyle={{
                    top: "60px",
                  }}
                  toastOptions={{
                    style: {
                      fontSize: "14px",
                      border: "1px solid #E7E8EB",
                      borderRadius: "4px",
                      fontWeight: 500,
                      overflow: "hidden",
                      background: "#0F172A",
                      color: "#fff",
                      paddingInline: "20px",
                    },
                  }}
                />
              </Box>
            </ChakraProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </RecoilRoot>
    </ErrorBoundary>
  );
}

export default App;
